export const meta: BlockMeta = {
  title: "Numbered Rows Sublist",
  description: "A sub list",
  keywords: ["content"],
  icon: "book-alt",
  category: "layouts",
}

import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"
import { useState } from "react"
import { tv } from "tailwind-variants"

const variants = tv({
  base: "my-2",
  variants: {
    admin: {
      true: "",
    },
  },
  defaultVariants: {
    admin: false,
  },
})

export default defineBlock("content/numbered-rows-sub", (props) => {
  return (
    <ol className={variants({ admin: env.admin })}>
      <InnerBlocks
        allowedBlocks={["content/numbered-rows-sub-item"]}
        template={[["content/numbered-rows-sub-item", null]]}
        orientation="vertical"
      />
    </ol>
  )
})
